<div class="preloader">
  <div class="container" nz-row nzAlign="middle" nzJustify="center" nzType="flex">
    <nz-card>
      <img alt="Card image cap" class="card-img-top" src="assets/promo-takad.jpg">
      <form [formGroup]="form" nz-form>
        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzFor="email">用戶</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input formControlName="userId" nz-input type="text"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzFor="email">密碼</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input autocomplete="on" formControlName="password" nz-input type="password"/>
          </nz-form-control>
        </nz-form-item>
      </form>
      <nz-divider></nz-divider>
      <div class="btn-panel">
        <button (click)="signOn()" [disabled]="processing" [nzLoading]="processing" nz-button nzType="primary">登 入
        </button>
      </div>
    </nz-card>
  </div>
</div>

